import * as CryptoJS from 'crypto-js';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EncryptDecryptService {

  constructor() { }

  // encrypt method will encrypt the data and return back in string formate.
  public encrypt(value:any) {
    if (value === undefined || value === null) {
      return '';
    } else {
      const keys = '0123456789^@3dm$'; // default key for encryption
      const key = CryptoJS.enc.Utf8.parse(keys);
      const vectorIV = CryptoJS.enc.Utf8.parse(keys);
      const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key,
        {
          keySize: 128 / 8,
          iv: vectorIV,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });
      return encrypted.toString();
    }
  }
  
  // The decrypt method will decrypt the value and return back in string format.
  public decrypt(value: any) {
    if (value === undefined || value === null) {
      return '';
    } else {
      try {
        const keys = '0123456789^@3dm$'; // default key for decryption
        const key = CryptoJS.enc.Utf8.parse(keys);
        const vectorIV = CryptoJS.enc.Utf8.parse(keys);
        const decrypted = CryptoJS.AES.decrypt(value, key, {
          keySize: 128 / 8,
          iv: vectorIV,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
      } catch (e) {
        // Display Error message
        const errorMsg = {
          messageText: e
        };
        return errorMsg.toString();
        throw e;
      }
    }
  }

  // using loginAuditNo as Key - This method will encrypt the data and return back in string format.
  public encryptUsingKey(value: { toString: () => any; } | null | undefined, encryptionKey: any): string {
    if (value === undefined || value === null) {
      return '';
    } else {
      const keys = encryptionKey; // default key for encryption
      const key = CryptoJS.enc.Utf8.parse(keys);
      const vectorIV = CryptoJS.enc.Utf8.parse(keys);
      const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key,
        {
          keySize: 128 / 8,
          iv: vectorIV,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });
      return encrypted.toString();
    }
  }

  // using loginAuditNo as Key - This method will decrypt the value and return back in string format.
  public decryptUsingKey(value: null | undefined, decryptionKey: any): string {
    if (value === undefined || value === null) {
      return '';
    } else {
      try {
        const keys = decryptionKey; // default key for decryption
        const key = CryptoJS.enc.Utf8.parse(keys);
        const vectorIV = CryptoJS.enc.Utf8.parse(keys);
        const decrypted = CryptoJS.AES.decrypt(value, key, {
          keySize: 128 / 8,
          iv: vectorIV,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
      } catch (e) {
        // Display Error message
        const errorMsg = {
          messageText: e
        };
        return errorMsg.toString();
        // throw e;
      }
    }
  }
}
